import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'professional' | 'personal' | 'pending' | 'success' | 'warning' | 'danger';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'pending', className }) => {
  const variantClasses = {
    professional: 'bg-blue-100 text-blue-800',
    personal: 'bg-gray-100 text-gray-800',
    pending: 'bg-amber-100 text-amber-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
};

interface QualificationBadgeProps {
  type: 'professional' | 'personal' | 'pending';
}

export const QualificationBadge: React.FC<QualificationBadgeProps> = ({ type }) => {
  const { t } = useTranslation();

  const config = {
    professional: { labelKey: 'badge.professional', variant: 'professional' as const },
    personal: { labelKey: 'badge.personal', variant: 'personal' as const },
    pending: { labelKey: 'badge.pending', variant: 'pending' as const },
  };

  const { labelKey, variant } = config[type];

  return <Badge variant={variant}>{t(labelKey)}</Badge>;
};
